import script from "./MainStatementAccountView.vue?vue&type=script&async=true&setup=true&lang=js"
export * from "./MainStatementAccountView.vue?vue&type=script&async=true&setup=true&lang=js"

import "./MainStatementAccountView.vue?vue&type=style&index=0&id=722341de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-722341de"]])

export default __exports__